export default __webpack_public_path__ + "80e06a0.png";